import moment from 'moment';

import getMiddleNameInitial from './getMiddleNameInitial';
import { MemberDetailsType } from '../features/settings/types';

const memberDetailsFormToParams = (
  formData: MemberDetailsType,
  isMinor: boolean,
  inviterEmail: string,
  inviterDisplay: string,
) => {
  const reference = !isMinor
    ? formData.email
    : `${inviterEmail}-${formData.firstName}-${formData.relationship}`;
  const middleNameInitial = getMiddleNameInitial(formData.middleName ?? '');

  const resource = {
    resourceType: 'Invitation',
    invitee: {
      reference,
      type: 'Patient',
      identifier: {
        system: 'http://proactivehealthtech.com/sid/d2md/v1/person/username',
        value: formData.email,
      },
      display: `${formData.firstName}${middleNameInitial} ${formData.lastName}`,
    },
    inviter: {
      type: 'Patient',
      identifier: {
        system: 'http://proactivehealthtech.com/sid/d2md/v1/person/username',
        value: inviterEmail,
      },
      display: inviterDisplay,
    },
    relationship: {
      text: formData.relationship,
    },
    workflow: {
      profile: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        phone: formData.phone,
        address: [
          {
            city: formData.city,
            country: formData.country,
            line: [formData.street ?? '', formData.unit ?? ''],
            postalcode: formData.zip,
            state: formData.state,
            use: 'home',
          },
        ],
        birthDate: moment(formData.birthdate).format('YYYY-MM-DD'),
        gender: formData.sex,
        name: [
          {
            family: formData.lastName,
            given: [formData.firstName, ...(formData.middleName ? [formData.middleName] : [])],
            use: 'usual',
          },
        ],
        telecom: [
          {
            system: 'email',
            ...(isMinor ? {} : { value: formData.email }),
          },
          {
            system: 'phone',
            ...(isMinor ? {} : { value: formData.phone, countryCode: '+1', country: 'US' }),
          },
        ],
        isMinor,
      },
    },
  };

  return { resource };
};

export default memberDetailsFormToParams;
